import React from 'react'
import T from 'prop-types'
import IT from 'react-immutable-proptypes'
import cx from 'classnames'
import {
  DropdownMenu,
  MenuItem
} from 'react-base'
import {
  DropTarget
} from 'react-dnd'
import Schema from '../Schema'
import MapperFieldToken, {
TOKEN_DND_ITEM_TYPE
} from './MapperFieldToken'
import {
  SCHEMA_ITEM_SHAPE,
  COLUMN_SHAPE
} from '../shapes'
// Single sortable item
class MapperColumnHeading extends React.PureComponent {
  static displayName = 'MapperColumnHeading'

  static propTypes = {
    columnKey: T.oneOfType([T.string, T.number]).isRequired,
    column: COLUMN_SHAPE,
    schemaDef: SCHEMA_ITEM_SHAPE,

    onMappingChange: T.func.isRequired,
    schemaFields: IT.orderedMap.isRequired,
    mapping: IT.mapOf(
      T.oneOfType([T.string, T.number]),
      T.oneOfType([T.string, T.number])
    ),

    connectDropTarget: T.func.isRequired,
		isOver: T.bool.isRequired,
    canDrop: T.bool.isRequired
  }

  handleDropdownSelect = fieldKey => {
    const {
      columnKey,
      onMappingChange
    } = this.props
    onMappingChange(fieldKey, columnKey)
  }

  handleDropdownReset = () => {
    const {
      columnKey,
      onMappingChange
    } = this.props
    onMappingChange(null, columnKey)
  }

  // renderDropdownLabel = () => {
  //   const {
  //     columnKey,
  //     schemaFields,
  //     mapping,
  //     onMappingChange,
  //   } = this.props
  //   // const schemaFields = schema && schema.getCreatable()
  //   const currentMappedField = mapping.get(columnKey, null)
  //   const currentMappedFieldSchemaDef = currentMappedField && schemaFields.get(currentMappedField)

  //   return (
  //     <div className="mapper_col_heading_label">
  //       {currentMappedField && currentMappedFieldSchemaDef ? (
  //         <MapperFieldToken
  //           onMappingChange={onMappingChange}
  //           schemaKey={currentMappedField}
  //           schemaDef={currentMappedFieldSchemaDef}
  //         />
  //       ) : 'Not Labeled'}
  //     </div>
  //   )
  // }

  render() {
    const {
      columnKey,
      canDrop,
      isOver,
      connectDropTarget,
      schemaFields,
      onMappingChange,
      mapping
    } = this.props
    const isActive = canDrop && isOver
    const currentMappedField = mapping.get(columnKey, null)
    const currentMappedFieldSchemaDef = currentMappedField && schemaFields.get(currentMappedField)

    return connectDropTarget(
      <div
        className={cx(
          `mapper_column_heading`,
          {
            'is_active': isActive,
            'can_drop': canDrop
          }
        )}
      >
        <div className="mapper_header">Column {+columnKey + 1}</div>
        <div className="mapped_label_wrap">
          {currentMappedField && currentMappedFieldSchemaDef ? (
            <MapperFieldToken
              onMappingChange={onMappingChange}
              schemaKey={currentMappedField}
              schemaDef={currentMappedFieldSchemaDef}
            />
          ) : 'Not Labeled'}
        </div>
        <DropdownMenu
          activeMenuKeys={ mapping.toArray() }
          buttonClasses="btn dropdown-toggle btn-xs btn-default btn-block mapper_column_dropdown"
          menuClasses="mapper_dropdown_menu"
          closeOnItemClick
          allowActiveItemClick
          label={ currentMappedField ? "Change Label" : "Select Label" }
        >
          <MenuItem
            allowActiveClick
            args={ [] }
            className={`mapper_dropdown_option`}
            onClick={ this.handleDropdownReset }
            dividerAfter
          ><span className="icon icon-blocked" /> None</MenuItem>
          {schemaFields && schemaFields.entrySeq().map(([fieldKey, field]) => {
            const isRequired = field.get('required') === true
            const isMapped = mapping.includes(fieldKey)
            return (
              <MenuItem
                allowActiveClick
                args={ [fieldKey] }
                key={ fieldKey }
                className={`mapper_dropdown_option ${isRequired ? 'is_required' : ''} ${isMapped ? 'is_mapped' : ''}`}
                onClick={ this.handleDropdownSelect }
              >
                { isMapped ? (
                  <span className="icon icon-checkmark" />
                ) : isRequired &&
                  <span className="icon icon-warning" />
                }
                { field.get('display') }
              </MenuItem>
            )
          })}
        </DropdownMenu>
      </div>
    )
  }
}

export default DropTarget(
  TOKEN_DND_ITEM_TYPE,
  {
    drop({columnKey}) {
      return {columnKey}
    }
  },
  (connect, monitor) => ({
		connectDropTarget: connect.dropTarget(),
		isOver: monitor.isOver(),
		canDrop: monitor.canDrop(),
	})
)(MapperColumnHeading)
